// extracted by mini-css-extract-plugin
export default {"header":"Header_header__RY0hI","scrolled":"Header_scrolled__-KaNZ","floors":"Header_floors__UKgZQ","hr":"Header_hr__w8A49"};